import {observer} from "mobx-react"
import {Linq, Pager, ScrollTable} from "../../ui"
import {useNavigate} from "react-router";
import {cmsDetailStore, cmsRulesListStore} from "../../../store";
import {PageContentTitle} from "@kroschke/react-ui";
import {
    convertDocumentType,
    convertScanDocumentRuleAction,
    convertScanDocumentRuleField
} from "../../../api";

const CmsRulesOverviewPage = observer(function CmsDetailPage() {
    const navigate = useNavigate()

    return <>
        <PageContentTitle
            actions={[
                {
                    label: 'Neue Regel anlegen',
                    cls: `is-primary`,
                    action: async () => {
                        navigate(`/cms/${cmsDetailStore.id}/scan-document-rule/create`)
                    }
                },
            ]}
        >Regeln</PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                <th>Name</th>
                <th>Feld</th>
                <th>Wert</th>
                <th>Aktion</th>
            </tr>
            </thead>
            <tbody>
            {cmsRulesListStore.items.map((val, index) => {
                const link = `/cms/${cmsRulesListStore.customerId}/scan-document-rule/${val.id}`
                return <tr key={index} className={`link`} onClick={() => {
                    navigate(link)
                }}>
                    <td><Linq to={`${link}`}>{val.name}</Linq></td>
                    <td><Linq to={`${link}`}>{convertScanDocumentRuleField(val.field)}</Linq></td>
                    <td><Linq to={`${link}`}>{convertDocumentType(val.value)}</Linq></td>
                    <td><Linq to={`${link}`}>{convertScanDocumentRuleAction(val.action)}</Linq></td>

                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={cmsRulesListStore.pages}/>
    </>
})

export {
    CmsRulesOverviewPage
}
